import React, { useEffect, useRef, useContext } from "react";
import { socialLinks } from "../../helpers/data.js";
import Toggler from "../../components/Toggler.jsx";
import "./social.scss";
import gsap from "gsap";

const Social = () => {
  const lineRef = useRef(null);
  const emailRef = useRef(null);
  const socialIconsRef = useRef(null);

  useEffect(() => {
    const verticalLine = document.querySelectorAll(".vertical-line");
    const tl = gsap.timeline();
    tl.to(verticalLine, {
      height: 100,
      duration: 1,
      ease: "power3.out",
      delay: 1.1,
    })
      .to(
        socialIconsRef.current.children,
        {
          opacity: 1,
          duration: 0.5,
          ease: "power3.out",
          stagger: 0.2,
        },
        "+=0.1"
      )
      .to(
        emailRef.current,
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power3.out",
        },
        "-=0.8"
      );
  }, []);

  return (
    <div className="social">
      <div className="wrapper">
        <div className="social-links-wrapper">
          <span className="icons" ref={socialIconsRef}>
            <div className="theme-toggler">
              <Toggler />
            </div>
            {socialLinks.map(({ link, logo, platform }, i) => (
              <a
                key={platform}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="icon">{logo}</div>
              </a>
            ))}
          </span>
          <div className="vertical-line" ref={lineRef}></div>
        </div>
        <div className="email-wrapper">
          <a href="mailto:muradgm@gmail.com">
            <p className="email" ref={emailRef}>
              muradgm@gmail.com
            </p>
          </a>
          <div className="vertical-line" ref={lineRef}></div>
        </div>
      </div>
    </div>
  );
};

export default Social;
